'use client';

import { Form } from '@/components/Form';
import { FormType } from '@/components/Form/types';
import { inventoryGridClassName } from '@/components/Inventory/InventoryGrid';
import { CustomInventoryItem } from '@/components/Inventory/InventoryItem';
import { inTransitDefaultImageUrl } from '@/constants/inventory';
import { NewInventoryFiltersContext } from '@/contexts/NewInventoryFiltersContext';
import { getClientLogger } from '@/lib/logger/pino-logger.client';
import { CustomComponentType } from '@/types/cms';
import { IDynamicsOptionSet } from '@/types/dynamicsForms';
import { Subtitle } from '@lamesarv-sdk/components';
import { GridInventory } from '@lamesarv-sdk/inventory';
import { IMetaData, InventoryField } from '@lamesarv-sdk/types';
import { useContext, useEffect } from 'react';
import { twMerge } from 'tailwind-merge';

interface IResultsEmptyProps {
  locationsOptionSet?: IDynamicsOptionSet;
  metadata: IMetaData;
}

export const ResultsEmpty = ({ locationsOptionSet, metadata }: IResultsEmptyProps) => {
  const { query } = useContext(NewInventoryFiltersContext);
  const logger = getClientLogger('components.SearchResults');

  useEffect(() => {
    logger.info('No search results found');
  }, []);

  return (
    <div className="">
      <Subtitle content="No Search Results found." className="normal-case font-medium text-lg" />
      <Form
        componentType={CustomComponentType.form}
        type={FormType.contactInfo}
        title="Tell us what are you looking for"
        data_tag="search-not-found"
        locationsOptionSet={locationsOptionSet}
      />
      <h2 className="mt-7 mb-2 px-2 w-full text-lg text-sage-700 uppercase font-bold">
        Below are some units you might be interested in.
      </h2>
      <GridInventory
        filters={`${InventoryField.isFlashSale}:=true`}
        queryConditional={query}
        baseCols={1}
        smCols={2}
        mdCols={2}
        lgCols={3}
        xlCols={3}
        gap={6}
        metadata={metadata}
        defaultImageUrl={inTransitDefaultImageUrl}
        CustomInventoryItem={CustomInventoryItem}
        className={twMerge(inventoryGridClassName, 'lg:gap-x-0 xl:gap-x-2 w-full')}
      />
    </div>
  );
};
